import axios from 'axios';

export const GlobalSearchReq = (category) => {
    const GlobalSearch = async (searchQuery) => {
        const url = category != null ? category === 5 ? '/api/crmGlobalSearch/searchFiles' : 'api/crmGlobalSearch/search/' + category : '/api/crmGlobalSearch/searchAll';
        const res = await axios.post(url, { searchQuery: searchQuery }).then(
            (response) => {
                if (response.status === 200) {
                    return { success: true, error: null, data: response.data };
                } else {
                    return { success: false, error: response.data.message, data: null };
                }
            },
            (error) => {
                return { success: false, error: 'Det gick inte att spara ändringen, vänligen kontakta alltid@consid.se.', data: null };
            }
        );            
        return res.data;
    };
    return GlobalSearch;
};
